import { Body, Header, Spacer } from '@spritz-finance/ui'
import { useCallback, useEffect } from 'react'
import styled from 'styled-components'
import loader from '../../../../assets/animations/spritz-logo-loop.gif'
import { GlassCard } from '../../../../components/Layout/GlassCard'
import { Row } from '../../../../components/Layout/Row'
import { useBillsDataQuery } from '../../../../graphql/generated/graphql'

const Loader = styled.img`
    width: 150px;
`

export const SearchingForBills = ({
    onBillSearchComplete,
}: {
    onBillSearchComplete: (foundBills: boolean) => void
}) => {
    const { data, startPolling, stopPolling } = useBillsDataQuery()
    const bills = data?.bills ?? []
    const foundBills = !!bills.find((bill) => !bill.manual)

    const toBills = useCallback((foundBills = false) => {
        window.history.replaceState({}, document.title)
        onBillSearchComplete(foundBills)
    }, [])

    useEffect(() => {
        if (!foundBills) {
            startPolling(2000)
        } else {
            stopPolling()
            toBills(true)
        }
    }, [foundBills, startPolling, stopPolling, toBills])

    useEffect(() => {
        const handler: NodeJS.Timeout = setTimeout(() => {
            toBills(false)
        }, 10000)

        return () => {
            clearTimeout(handler)
        }
    }, [toBills])

    return (
        <GlassCard>
            <Row align="center">
                <Body.Bold size={16}>Searching for bills...</Body.Bold>
            </Row>
            <Spacer height={16} />
            <Row align="center">
                <Body.Med size={14} align="center">
                    Spritz is currently doing a search to see if it can automatically find some of
                    your bills for you. This shouldn't take more than a few seconds.
                </Body.Med>
            </Row>
            <Row align="center">
                <Loader src={loader} alt="Spritz logo loader" />
            </Row>
        </GlassCard>
    )
}
